var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCoachAreaMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.83V14H5.83A3.001 3.001 0 1 1 2 10.17V5.83a3.001 3.001 0 1 1 2 0v4.34A3.008 3.008 0 0 1 5.83 12H12V5.83a3.001 3.001 0 1 1 2 0zM2 12v2h2v-2H2zM2 2v2h2V2H2zm10 0v2h2V2h-2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoachAreaMenu);
export default __webpack_public_path__ + "static/media/icon_coach-area-menu.c5d4c4ee312bed4742aef9b7ec09532f.svg";
export { ForwardRef as ReactComponent };